import React, { useState, useEffect } from "react";
import axios from 'axios';
import Elem1Submit from '../Elem1-Submit/Elem1Submit';
import Elem4Next from "../Elem4-Next/Elem4Next";
import './Sec2TakeSurvey.css';
import { useNavigate } from 'react-router-dom';

function Sec2TakeSurvey() {

    // session storage
    useEffect(() => {
        const sessionStarted = localStorage.getItem('sessionStarted');
        if (!sessionStarted) {
        // Clear local storage
        localStorage.clear();
        // Set sessionStarted flag to indicate session has started
        localStorage.setItem('sessionStarted', 'true');
        }
    }, []);

    const [industryValue, setIndustryValue] = useState(() => {
        const savedIndustryValue = localStorage.getItem("industryValue");
        return savedIndustryValue ? savedIndustryValue : '';
    });

    const [formData, setFormData] = useState(() => {
        const savedData = localStorage.getItem("formData");
        return savedData ? JSON.parse(savedData) : {
          name: '',
          designation: '',
          organization: '',
          established_year: '',
          email_id: '',
          type: ''
        };
    });

    useEffect(() => {
        localStorage.setItem("formData", JSON.stringify(formData));
      }, [formData]);

    const navigate = useNavigate();
    const[emailError, setEmailError] = useState('');
    const[nameError, setnameError] = useState('');
    const[designationError, setdesignationError] = useState('');
    const[organizationError, setorganizationError] = useState('');
    const[industryError, setIndustryError] = useState('');
    const[establishedYearError, setEstablishedYearError] = useState('');

    // eslint-disable-next-line
    const [showRegistrationForm, setShowRegistrationForm] = useState(false);

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        // Clear specific field errors when they are being modified
        switch (name) {
            case 'email_id':
                setEmailError('');
                break;
            case 'name':
                setnameError('');
                break;
            case 'designation':
                setdesignationError('');
                break;
            case 'organization':
                setorganizationError('');
                break;
            case 'established_year':
                setEstablishedYearError('');
                break;
            default:
                break;
        }
    };

    const handleIndustryChange = (e) => {
        const value = e.target.value;
        setIndustryValue(value);
        setFormData({
            ...formData,
            type: value
        });
        localStorage.setItem("industryValue", value);
    };

    const validateEmail = email => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }    

    const handleNext = event => {
        event.preventDefault();
        if (!validateEmail(formData.email_id)) {
            setEmailError(
                <p className="error-message">
                    Email is invalid
                </p>
            );
            return;
        }
               
        axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/verify-email-existence/", formData)
            .then(res => {
                console.log("Verify Email Existence Result");
                console.log(res);
                if ((res.data.status === 1) || (res.data.status === 0)){
                    if(res.data.type === 0){
                    setShowRegistrationForm(true);
                    } else {
                        const industryVal = res.data.type;
                        console.log("First Page - Email Exists");
                        console.log(industryVal);
                        navigate('/survey', { state: { industryValue: industryVal,basicDetailFormData: formData} });
                    }
                }
            })
            .catch(err => {
                console.error('Error submitting feedback:', err);
            });
    };

    const handleSubmit = event => {
        event.preventDefault();

        if (!validateEmail(formData.email_id)) {
            setEmailError(
                <p className="error-message">
                    Email is invalid
                </p>
            );
            return;
        }
    
        if (industryValue === '') {
            // Set error state and return
            setIndustryError(<p className="error-message">Industry is required</p>);
            return;
        }
        // Check if any field is empty
        if (
            formData.name.trim() === '' ||
            formData.designation.trim() === '' ||
            formData.organization.trim() === '' ||
            formData.email_id.trim() === '' ||
            formData.established_year.trim() === ''
        ) {
            // Display error messages for empty fields
            if (formData.name.trim() === '') {
                setnameError(<p className="error-message">Name is required</p>);
            }
            if (formData.designation.trim() === '') {
                setdesignationError(<p className="error-message">Designation is required</p>);
            }
            if (formData.organization.trim() === '') {
                setorganizationError(<p className="error-message">Organization is required</p>);
            }
            if (formData.email_id.trim() === '') {
                setEmailError(<p className="error-message">Email is required</p>);
            }
            if (formData.established_year.trim() === '') {
                setEstablishedYearError(<p className="error-message">Established Year is required</p>);
            }
            return;
        }
    
        // Proceed with form submission
        axios.post('https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/insert-basic-details/', formData)
        .then(res => {
            console.log()
            console.log(res.data);
            navigate('/survey',{ state: { industryValue: industryValue, basic_details_id: res.data.basic_details_id,insertStatus: res.data.status} })
        })
    };

    
    return (
        <div className="takethesurvey">
            <h2>TAKE THE SURVEY</h2>
            <div>
                {!showRegistrationForm && (
                <form className='Form-Container' onSubmit={handleNext}>
                    <div className='Form-Sub-Container-text'>
                        <input className='Form-input' type="email" name="email_id" placeholder='Email Id' value={formData.email_id} onChange={handleChange} required />
                        {emailError && <p className='error-message'>{emailError}</p>}
                    </div>
                    <div className="Takethesurvey-submit">
                        <Elem4Next onClick={handleNext}/>
                    </div>
                </form>
                )}
                {showRegistrationForm && (
                <form className='Form-Container RegistrationForm' onSubmit={handleSubmit}>
                    <div className='Form-Sub-Container-text'>
                        <input className='Form-input' type="text" name="name" placeholder='Name' value={formData.name} onChange={handleChange} required />
                        {nameError && <p className='error-message'>{nameError}</p>}
                    </div>
                    <div className='Form-Sub-Container-text'>
                        <input className='Form-input' type="text" name="designation" placeholder='Designation' value={formData.designation} onChange={handleChange} required />
                        {designationError && <p className='error-message'>{designationError}</p>}
                    </div>
                    <div className='Form-Sub-Container-text'>
                        <input className='Form-input' type="text" name="organization" placeholder='Organization' value={formData.organization} onChange={handleChange} required />
                        {organizationError && <p className='error-message'>{organizationError}</p>}
                    </div>
                    <div className='Form-Sub-Container-text'>
                        <input className='Form-input' type="text" name="established_year" placeholder='Established Year' value={formData.established_year} onChange={handleChange} required />
                        {establishedYearError && <p className='error-message'>{establishedYearError}</p>}
                    </div>
                    <div className='Form-Sub-Container-text'>
                        <input className='Form-input' type="email" name="email_id" placeholder='Email Id' value={formData.email_id} onChange={handleChange} required />
                        {emailError && <p className='error-message'>{emailError}</p>}
                    </div>
                    <div className='Form-Sub-Container'>
                    {industryError && <p className='error-message'>{industryError}</p>}
                        <div className='Form-Sub-Container-radio'>
                            <input className='Form-input' type='radio' name='type' value='1' onChange={handleIndustryChange} checked={industryValue === '1'} />
                            <label>ER&D</label>
                        </div>
                        <div className='Form-Sub-Container-radio'>
                            <input className='Form-input' type='radio' name='type' value='2' onChange={handleIndustryChange} checked={industryValue === '2'} />
                            <label>IT</label>
                        </div>
                        
                    </div>
                    <div className="Takethesurvey-submit">
                        <Elem1Submit onClick={handleSubmit}/>
                    </div>
                </form>
                    )}
            </div>
        </div>
    );
}

export default Sec2TakeSurvey;
